import _ from 'lodash';
import Util from '@dap/shared-utils';
import UtilCache from '@dap/shared-utils/cache';
// 特殊处理地址栏取渠道id
import { getToolsAccountStewardParams } from './utils/autoURLParser';

// 保存所有页面地址及名称
let monitorConfigMap = null;
let monitorList = [];
// 设置配置对象
const setMonitorConfigMap = () => {
    if (monitorConfigMap) {
        return;
    }
    monitorList = UtilCache.getCacheWithChain('monitorList');
    monitorConfigMap = new Map();
    for (const item of monitorList) {
        monitorConfigMap.set(item.url, item.name);
    }
};

// 判断名称是否包含占位符及高级配置
const getHasStatus = (currentItem) => {
    let wildcardStatus = !!currentItem.name.match(/{{/g) && !!currentItem.name.match(/}}/g);
    return wildcardStatus && !!currentItem.advanced;
};

// 通过正则匹配页面
const getCurrentPageState = (url, ble) => {
    // 转换后的当前页面地址
    const currentConvertUrl = url || '';
    // 配置列表中存在就返回对象
    const currentConfigObj = monitorList.find((item) => {
        let reg = null;
        try {
            reg = new RegExp(item.url, 'ig');
        } catch (e) {
            // console.log('模块地址-正则表达式错误: ' + e);
        }
        return Object.prototype.toString.call(reg) === '[object RegExp]' ? reg.test(currentConvertUrl) : false;
    });

    return ble ? currentConfigObj : !!currentConfigObj;
};

// 高级配置-市场
const region = (templateName, id) => {
    //  市场id 没有默认 中国 1
    const regionId = id || 1;
    const regionName = Util.getNameInListBy(UtilCache.getCacheWithChain('baseConfig.regions'), regionId, {
        value: 'id',
        name: 'name',
    });
    return templateName.replace(/{{region}}/g, `${regionName}`);
};

// 高级配置-渠道
const spreader = (templateName, spreaderId) => {
    const spreaderName = Util.getNameInListBy(UtilCache.getCacheWithChain('baseConfig.spreaders'), spreaderId, {
        value: 'spreader_id',
        name: 'name',
    });
    return templateName.replace(/{{spreader}}/g, `${spreaderName}`);
};

// 高级配置-事件优选
const eventOptimization = (templateName, id) => {
    // 默认 CPE渠道 1
    const eventOptimizationId = id || 1;
    const spreaderName = Util.getNameInListBy(
        UtilCache.getCacheWithChain('tools.event.choose')?.event_type.concat([
            { id: 4, name: '巨量引擎' },
            { id: 5, name: '广点通' },
        ]),
        eventOptimizationId,
        { value: 'id', name: 'name' }
    );
    return templateName.replace(/{{eventOptimization}}/g, `${spreaderName}`);
};

// 高级配置-事件回传
const eventReturn = (templateName, id) => {
    // 默认 CPE渠道 0
    const eventReturnId = id || 0;
    const spreaderName = Util.getNameInListBy(UtilCache.getCacheWithChain('tools.event.warnList'), eventReturnId, {
        value: 'value',
        name: 'name',
    });
    return templateName.replace(/{{eventReturn}}/g, `${spreaderName}`);
};

// 获取指定的参数在本地的缓存,返回拼接好的name
const getHandleName = (currentUrl, currentItem) => {
    // 处理后名称
    let handleName = '';
    // 	模块路径
    let pathname = currentItem.url;
    // 模块名称
    let templateName = currentItem.name;
    // 用于取本地缓存的路径
    let localPath = currentItem.local_path;

    // 工具库-账户管家
    if (currentUrl.includes('tools/account-steward/account-list')) {
        const { uid } = getToolsAccountStewardParams(window.location.href);
        handleName = spreader(templateName, uid);
        return handleName;
    }

    // currentId
    let currentId = null;
    let getHandleNameFn = {
        region,
        spreader,
        eventOptimization,
        eventReturn,
    };
    if (localPath) {
        currentId = +UtilCache.getCacheWithChain(localPath);
    } else {
        // 获取地址栏中对应的
        let index = pathname.indexOf('(');
        let lastParams = currentUrl.substring(index);
        let paramsArr = lastParams.split('/');
        currentId = paramsArr.length ? paramsArr[0] : null;
    }
    // 获取id对应名称
    handleName = getHandleNameFn[currentItem.advanced](templateName, +currentId);
    return handleName;
};

// 获取页面信息
const autoGetName = (pathname = '') => {
    // 默认配置
    let options = {
        name: '',
        url: window.location.href,
        path: pathname || '',
        host: window.location.host,
    };
    // 页面状态
    const currentPageState = getCurrentPageState(pathname, true);
    if (currentPageState) {
        // 判断名称是否包含占位符及高级配置路径
        options.name = getHasStatus(currentPageState)
            ? getHandleName(pathname, currentPageState)
            : monitorConfigMap.get(pathname);
    }
    // console.log('页面信息', options, '----------');
    return options;
};

export { autoGetName, setMonitorConfigMap, getHasStatus, getCurrentPageState };

export default autoGetName;
